export default "__VITE_ASSET__D0xhHK3P__"